import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mobilePhone'
})
export class MobilePhonePipe implements PipeTransform {

  transform(value: string | number | null | undefined): string {
    if (value == null) {
      return '-';
    }

    const formattedValue = value.toString();
    if (formattedValue.length === 10) {
      // Telefone format: (12) 3456-7890
      return formattedValue.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else if (formattedValue.length === 11) {
      // Telefone com DDD format: (12) 34567-8901
      return formattedValue.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    return formattedValue;
  }

}
